import React, { useMemo } from "react";
import { AppPage, MimaButton, MimaTable } from "../../components";
import {
  AddCatalogueModalContainer,
  EditCatalogueModalContainer,
  SingleCatalogueModalContainer,
} from "../../containers";
import { AnimatePresence } from "framer-motion";
import constant from "../../utils/constant";
import moment from "moment";
import MimaOptionMenu from "../../components/OptionMenu/";

const PublicCatalogue = ({
  modalConstant,
  openCatalogue,
  closeModal,
  isLoading,
  catalogueData,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
  openCatalogueHandler,
}) => {
  const tableData = useMemo(() => {
    if (catalogueData?.status === constant.Success) {
      return catalogueData?.data?.styles || [];
    }
    return [];
  }, [catalogueData]);

  const options = [
    {
      label: "View More",
      value: "View More",
    },
    {
      label: "Edit Catalogue",
      value: "Edit Catalogue",
    },
  ];

  const optionHandler = (option, item) => {
    if (option.value === "Edit Catalogue") {
      openCatalogueHandler(modalConstant.editCatalogue, item);
    } else if (option.value === "View More") {
      openCatalogueHandler(modalConstant.singleCatalogue, item);
    }
  };

  const tableColumns = [
    {
      Header: "Date And Time",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original?.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Style Name",
      accessor: "name",
    },
    {
      Header: "Image",
      accessor: "imageUrls",
      Cell: ({ cell }) => {
        const imageUrls = cell.row.original.imageUrls;
        return (
          <span>
            <img
              src={imageUrls[0]}
              alt="catalogue style"
              style={{ width: "5rem", height: "5rem", objectFit: "Cover" }}
            />
          </span>
        );
      },
    },
    {
      Header: "Designer Name",
      accessor: "designerName",
    },
    {
      Header: "Gender",
      accessor: "gender",
    },
    {
      Header: "No. of Likes",
      accessor: "likeCount",
    },
    {
      Header: "No. of Comments",
      accessor: "commentCount",
    },
    // {
    //   Header: "Actions",
    //   Cell: ({ cell }) => {
    //     const item = cell.row.original;
    //     return (
    //       <span
    //         className="tableAction__text"
    //         onClick={() => {
    //           openCatalogue(modalConstant.singleCatalogue, item);
    //         }}
    //       >
    //         View More
    //       </span>
    //     );
    //   },
    // },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <MimaOptionMenu
            options={options}
            onOptionSelected={(option) => {
              optionHandler(option, item);
            }}
          />
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Public Catalogue">
      <div
        style={{
          display: "flex",
          gap: "3rem",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <MimaButton
          title="Add to Catalogue"
          variant="colorable"
          buttonColor="var(--color-dark)"
          onClick={() => {
            openCatalogueHandler(modalConstant.addCatalogue);
          }}
          width={28}
        />

        <div
          style={{
            backgroundColor: "var(--color-primary-3)",
            padding: "2rem",
            fontSize: "1.4rem",
            borderRadius: "1rem",
          }}
        >
          {catalogueData?.data?.totalCounts} Catalogues Added
        </div>
      </div>

      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Feedback"
        searchVariant="wide"
        totalItems={catalogueData?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {openCatalogue !== modalConstant.close && (
        <div className="modal">
          <AnimatePresence>
            {openCatalogue === modalConstant.addCatalogue && (
              <AddCatalogueModalContainer closeModal={closeModal} />
            )}
            {openCatalogue === modalConstant.singleCatalogue && (
              <SingleCatalogueModalContainer closeModal={closeModal} />
            )}
            {openCatalogue === modalConstant.editCatalogue && (
              <EditCatalogueModalContainer closeModal={closeModal} />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default PublicCatalogue;
